import { HttpClient, clientName } from "./http/http-client";
import { LOGIN } from "../store/app/types";

export const LOGIN_URL = '/LOGIN';
export const LOGINPL_URL = '/login.pl';
export const LOGOUT_URL = '/support.pl';
export const INDEX_START_URL = '/index.pl?start=1';
export const INDEX_URL = '/index.pl';

export const AuthenticationService = {
  login: (user) => {
    return HttpClient.post(LOGIN_URL, {
      credential_0: user.username,
      credential_1: user.password,
      destination: `/${clientName}/index.pl?start=1`
    });
  },
  logout: () => {
    return HttpClient.post(LOGOUT_URL, {
      action: 'deletesession',
    })
  },
  redirectStart: () => {
    return HttpClient.get3(INDEX_START_URL);
  },
  logoutSharedUser: () => {
    return HttpClient.get3(INDEX_URL, {
      start: 2,
      action: 'logout_shared_user'
    });
  },
  
  resetPassword: ({
    user_name_email
  }) => HttpClient.post(LOGINPL_URL, {
    reset_pw: '1',
    user_name_email,
  }),
  // https://dev.berlin3.com/berlin3/ext_noauth.pl?section=recover_pw&action=url&source=d_user
  resetPasswordURL: () => HttpClient.get('/ext_noauth.pl', {
    section: 'recover_pw',
    action: 'url',
    source: 'd_user'
  }),
}

/**
 * If the unauthorized redirects are from these routes the redirection data wont be set.
 * For example: /login, /signup, /register etc.
 */
const invalidRedirectRoutes = ['mainLogin', 'logout', 'signup'];

export const isValidRedirectionRoute = (value) => {
  return !invalidRedirectRoutes.includes(value);
}